import { fromJS } from 'immutable';
import {
	FETCH_REFERRERS,
	FETCH_REFERRERS_SUCCESS,
	FETCH_REFERRERS_FAILURE,
	APPROVE_REFERRER,
	APPROVE_REFERRER_SUCCESS,
	APPROVE_REFERRER_FAILURE,
	DEACTIVATE_REFERRER,
	DEACTIVATE_REFERRER_SUCCESS,
	DEACTIVATE_REFERRER_FAILURE,
} from './constants';

export const initialState = fromJS({
	referrers: [],
	pagination: { page: 1, limit: 20, total: 0 },
	loading: false,
	error: '',
	actionLoading: false,
	actionError: '',
});

function adminReferrersReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_REFERRERS:
			return state.set('loading', true).set('error', '');
		case FETCH_REFERRERS_SUCCESS:
			return state
				.set('loading', false)
				.set('referrers', fromJS(action.data.referrers))
				.set('pagination', fromJS(action.data.pagination));
		case FETCH_REFERRERS_FAILURE:
			return state.set('loading', false).set('error', action.error);
		case APPROVE_REFERRER:
		case DEACTIVATE_REFERRER:
			return state.set('actionLoading', true).set('actionError', '');
		case APPROVE_REFERRER_SUCCESS:
		case DEACTIVATE_REFERRER_SUCCESS:
			return state.set('actionLoading', false);
		case APPROVE_REFERRER_FAILURE:
		case DEACTIVATE_REFERRER_FAILURE:
			return state.set('actionLoading', false).set('actionError', action.error);
		default:
			return state;
	}
}

export default adminReferrersReducer;
